export const wordpressArticlesUiHelper = (_) => {
  const PUBLISH = "publish";
  const FUTURE = "future";
  const DRAFT = "draft";
  const PENDING = "pending";
  const PRIVATE = "private";

  let ui = {
    showEditBtn: false,
    showDeleteBtn: false,
    showMaskLayer: false,
    mainInfoText: "",
    detailInfoText: "",
    id: _?.id,
    title: _?.title?.rendered,
    content: _?.content?.rendered,
    featuredImage: _?._embedded["wp:featuredmedia"]?.["0"].source_url,
    featuredMediaId: _?._embedded["wp:featuredmedia"]?.["0"].id,
    status: "",
    date: _?.date,
  };

  switch (_?.status) {
    case PUBLISH:
      ui.status = "منتشر شده";
      ui.showEditBtn = true;
      break;
    case FUTURE:
      ui.status = "آینده";
      break;
    case DRAFT:
      ui.status = "پیش نویس";
      ui.showMaskLayer = true;
      ui.mainInfoText = "محتوا در انتظار بررسی و تایید است";
      break;
    case PENDING:
      ui.status = "معلق";
      ui.showEditBtn = true;
      ui.showDeleteBtn = true;
      ui.showMaskLayer = true;
      ui.mainInfoText = "محتوا تایید نشد";
      ui.detailInfoText = "موارد نیاز به اصلاح در متن مقاله ثبت شده است";
      break;
    case PRIVATE:
      ui.status = "خصوصی";
      break;
    default:
      ui.status = "نامشخص";
  }

  return ui;
};

export const wordpressCommentsUiHelper = (_) => {
  const APPROVE = "approved";
  const HOLD = "hold";
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  let ui = {
    id: _?.id,
    showReplyBtn: false,
    selfComment: _?.selfComment,
    author: _?.author,
    avatar: _?.author_avatar_urls["96"],
    author_name: _?.author_name,
    post: _?.post,
    content: _?.content?.rendered,
    parent: _?.parent,
    date: _?.date,
  };

  if (_?.author === expertProfile.wordpressAuthorId) {
    ui.selfComment = true;
  }

  if (_?.status === APPROVE) {
    ui.showReplyBtn = true;
  }

  return ui;
};
